import { render } from "./weeklyArticleDetail.vue?vue&type=template&id=2d1c837f&scoped=true"
import script from "./weeklyArticleDetail.vue?vue&type=script&lang=js"
export * from "./weeklyArticleDetail.vue?vue&type=script&lang=js"

import "./weeklyArticleDetail.vue?vue&type=style&index=0&id=2d1c837f&lang=scss&scoped=true"
import "./weeklyArticleDetail.vue?vue&type=style&index=1&id=2d1c837f&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1c837f"]])

export default __exports__